module.exports = __webpack_public_path__ + "media/site/images/products/saas_actionplan@2x-78aacc2a8534499742e3b8dff5a56b5b.png";